import makeGraphics from 'core/display/simple/Graphics'

export default class NoiseGraphics extends PIXI.Container{
  constructor(data) {
    super()
    const alpha = data.alpha == undefined ? 0.8 : data.alpha
    this.rect = new makeGraphics({ ...data, alpha })
    this.rect.interactive = true
    this.rect.buttonMode = true
    this.addChild(this.rect)
  }
}
